import React from 'react';
import { PRODUCT_DATA } from '../utils/constants';
import { scrollToOffer } from '../utils/scroll';
export const HeroSection: React.FC = () => {
  return <section className="pt-28 pb-16 px-4 bg-gradient-to-b from-blue-50 to-white" data-id="element-130">
      <div className="container mx-auto max-w-6xl text-center" data-id="element-131">
        <h1 className="text-4xl md:text-6xl font-extrabold text-blue-900 mb-6 leading-tight" data-id="element-132">
          Megapack Folclore Listo: El Sistema{' '}
          <span className="text-blue-600" data-id="element-133">Completo</span> para Llenar Tus Clases
        </h1>

        <p className="text-xl md:text-2xl text-gray-700 max-w-3xl mx-auto mb-10" data-id="element-134">
          {PRODUCT_DATA.subtitle}
        </p>

        <div className="relative max-w-4xl mx-auto mb-8 cursor-pointer group" onClick={scrollToOffer} data-id="element-135">
          <div className="relative w-full aspect-[16/9] md:aspect-[21/9] flex justify-center items-center" data-id="element-136">
            {/* Main Product Image */}
            <img src={PRODUCT_DATA.mainImage} alt="Megapack Folclore Listo" className="w-[80%] md:w-[60%] object-contain z-10 drop-shadow-2xl transition-transform duration-500 group-hover:scale-105" data-id="element-137" />
          </div>
          <p className="text-lg font-semibold text-gray-600 mt-4" data-id="element-138">
            5 Recursos + 4 Bonus Gratuitos
          </p>
        </div>

        <button onClick={scrollToOffer} className="bg-green-500 hover:bg-green-600 text-white rounded-full py-5 px-10 font-bold text-xl md:text-2xl shadow-[0_0_20px_rgba(34,197,94,0.4)] hover:shadow-[0_0_30px_rgba(34,197,94,0.6)] transition-all duration-300 animate-pulse-fast" data-id="element-139">
          SÍ, QUIERO EL MEGAPACK AHORA
        </button>
      </div>
    </section>;
};